import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dealer-invoice-list-page" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "action-bar" }
const _hoisted_4 = { class: "batch-actions" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = { class: "vxe-table-container" }
const _hoisted_7 = { class: "action-links" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "pagination-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_OioTag = _resolveComponent("OioTag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_OioPagination = _resolveComponent("OioPagination")!
  const _component_ImportInvoiceContent = _resolveComponent("ImportInvoiceContent")!
  const _component_OperationLogDialog = _resolveComponent("OperationLogDialog")!
  const _component_BillingBillDetailPage = _resolveComponent("BillingBillDetailPage")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oio_form, {
        layout: "inline",
        data: _ctx.searchForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_oio_form_item, { label: "开票单编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.code,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.code) = $event)),
                placeholder: "请输入开票单编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          (!_ctx.isDistributor)
            ? (_openBlock(), _createBlock(_component_oio_form_item, {
                key: 0,
                label: "经销商名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oio_input, {
                    value: _ctx.searchForm.distributorName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.distributorName) = $event)),
                    placeholder: "请输入经销商名称",
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isDistributor)
            ? (_openBlock(), _createBlock(_component_oio_form_item, {
                key: 1,
                label: "ERP客户编码"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.searchForm.distributorErpCode,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.distributorErpCode) = $event)),
                    mode: "tags",
                    placeholder: "支持批量输入/粘贴",
                    "allow-clear": "",
                    style: {"width":"200px"},
                    class: "single-line-select",
                    "token-separators": [',', '，', ' ', '\n'],
                    open: false,
                    "suffix-icon": null
                  }, null, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_oio_form_item, { label: "销售组织编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.salesOrgCode,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.salesOrgCode) = $event)),
                placeholder: "请输入销售组织编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "销售组织名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.salesOrgName,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.salesOrgName) = $event)),
                placeholder: "请输入销售组织名称",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "账单状态" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.searchForm.status,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.status) = $event)),
                placeholder: "请选择",
                "allow-clear": "",
                style: {"width":"140px"},
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "PENDING" }, {
                    default: _withCtx(() => [
                      _createTextVNode("待确认")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "CONFIRMING" }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认中")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "CONFIRMED" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已确认")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "创建时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _ctx.searchForm.dateRange,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchForm.dateRange) = $event)),
                placeholder: ['开始日期', '结束日期']
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_oio_button, {
                type: "primary",
                onClick: _ctx.handleSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_oio_button, {
                style: {"margin-left":"8px"},
                onClick: _ctx.handleReset
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 0,
              type: "primary",
              disabled: _ctx.selectedPendingBills.length === 0,
              onClick: _ctx.handleBatchConfirm,
              loading: _ctx.batchLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 批量整单开票 ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick", "loading"]))
          : _createCommentVNode("", true),
        (!_ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 1,
              disabled: _ctx.selectedRowKeys.length === 0,
              onClick: _ctx.handleBatchExport,
              loading: _ctx.exportLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 导出明细 ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick", "loading"]))
          : _createCommentVNode("", true),
        (!_ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 2,
              onClick: _ctx.handleImport
            }, {
              default: _withCtx(() => [
                _createTextVNode("导入")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (!_ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 0,
              onClick: _ctx.fetchData,
              loading: _ctx.loading
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_ReloadOutlined)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 刷新 ")
              ]),
              _: 1
            }, 8, ["onClick", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vxe_table, {
          ref: "tableRef",
          border: "",
          "column-config": { resizable: true },
          height: "auto",
          size: "small",
          "show-overflow": "",
          "show-header-overflow": "",
          data: _ctx.tableData,
          loading: _ctx.loading,
          "scroll-x": { enabled: true },
          "scroll-y": { enabled: true, gt: 0 },
          "tooltip-config": { enterable: true },
          "checkbox-config": { highlight: true },
          "row-config": { isCurrent: true, isHover: true },
          onCheckboxChange: _ctx.onCheckboxChange,
          onCheckboxAll: _ctx.onCheckboxChange
        }, {
          default: _withCtx(() => [
            (!_ctx.isDistributor)
              ? (_openBlock(), _createBlock(_component_vxe_column, {
                  key: 0,
                  type: "checkbox",
                  width: "50",
                  fixed: "left",
                  align: "center"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_vxe_column, {
              field: "code",
              title: "开票单编码",
              width: "160",
              fixed: "left"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorCode",
              title: "平台客户编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "salesOrgCode",
              title: "销售组织编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "salesOrgName",
              title: "销售组织名称",
              width: "140"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorErpCode",
              title: "ERP客户编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorName",
              title: "经销商名称",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              field: "accountStartDate",
              title: "对账开始时间",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(row.accountStartDate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "accountEndDate",
              title: "对账结束时间",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(row.accountEndDate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "totalAmount",
              title: "开票总额",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getAmountClass(row.totalAmount))
                }, _toDisplayString(_ctx.formatAmount(row.totalAmount)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "invoicedAmount",
              title: "已开票金额",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getAmountClass(row.invoicedAmount))
                }, _toDisplayString(_ctx.formatAmount(row.invoicedAmount)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "remainAmount",
              title: "剩余可开金额",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getAmountClass(row.remainAmount))
                }, _toDisplayString(_ctx.formatAmount(row.remainAmount)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "status",
              title: "账单状态",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_OioTag, {
                  color: _ctx.getBillStatusColor(row.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getBillStatusText(row.status)), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "createUserName",
              title: "创建人",
              width: "100"
            }),
            _createVNode(_component_vxe_column, {
              field: "createDate",
              title: "创建时间",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              field: "writeUserName",
              title: "更新人",
              width: "100"
            }),
            _createVNode(_component_vxe_column, {
              field: "writeDate",
              title: "更新时间",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              title: "操作",
              width: "320",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_7, [
                  (!_ctx.isDistributor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleDetail(row))
                      }, "详情", 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (!_ctx.isDistributor && _ctx.canEdit(row.status))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.handleEdit(row))
                      }, "部分开票", 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (!_ctx.isDistributor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        onClick: ($event: any) => (_ctx.handleConfirm(row)),
                        style: {"color":"#ff4d4f"}
                      }, "整单开票", 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (!_ctx.isDistributor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        onClick: ($event: any) => (_ctx.handleLog(row))
                      }, "操作日志", 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (_ctx.canDownloadInvoice(row.status))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 4,
                        onClick: ($event: any) => (_ctx.handleDownload(row))
                      }, "下载发票", 8, _hoisted_12))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "loading", "onCheckboxChange", "onCheckboxAll"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_OioPagination, {
          currentPage: _ctx.pagination.current,
          pageSize: _ctx.pagination.pageSize,
          total: _ctx.pagination.total,
          showTotal: "",
          showJumper: "",
          onChange: _ctx.handlePaginationChange
        }, null, 8, ["currentPage", "pageSize", "total", "onChange"])
      ])
    ]),
    _createVNode(_component_ImportInvoiceContent, {
      visible: _ctx.importVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.importVisible) = $event)),
      onSuccess: _ctx.fetchData
    }, null, 8, ["visible", "onSuccess"]),
    _createVNode(_component_OperationLogDialog, {
      visible: _ctx.logVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.logVisible) = $event)),
      "billing-bill": _ctx.currentLogBill
    }, null, 8, ["visible", "billing-bill"]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer billing-detail-drawer",
      visible: _ctx.detailVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detailVisible) = $event)),
      title: _ctx.detailMode === 'edit' ? '部分开票' : '开票单详情',
      width: 1400,
      placement: "right",
      "destroy-on-close": true,
      onClose: _ctx.handleDetailClose
    }, {
      default: _withCtx(() => [
        (_ctx.detailVisible)
          ? (_openBlock(), _createBlock(_component_BillingBillDetailPage, {
              key: 0,
              "bill-id": _ctx.detailBillId,
              mode: _ctx.detailMode
            }, null, 8, ["bill-id", "mode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "onClose"])
  ]))
}